import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

/**
 * Componente que representa una maleta redemida.
 *
 */
@Component({
    selector: 'am-bag-redeemed',
    templateUrl: './am-bag-redeemed.component.html',
    styleUrls: ['./am-bag-redeemed.component.scss'],
    standalone: false
})
export class AmBagRedeemedComponent implements OnInit,OnChanges {

  /**
   * Indica si la maleta ha sido canjeada o no. Se pasa como un input desde el componente padre.
   * 
   * @type {boolean}
   * @default false
   */
  @Input() active: boolean = false;

  /**
   * Evento emitido cuando se realiza el canje de la maleta.
   * 
   * @type {EventEmitter<any>}
   */
  @Output() onRedeeme: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Ruta de la imagen mostrada para la maleta.
   * Esta imagen cambia dependiendo del estado de la maleta (canjeada o no).
   * 
   * @type {string}
   * @default './assets/images/bags/icon-bag-gift.svg'
   */
  image: string = './assets/images/bags/icon-bag-gift.svg';

  /**
   * Etiqueta que se muestra junto a la imagen de la bolsa.
   * Cambia dependiendo del estado de la bolsa (canjeada o no).
   * 
   * @type {string}
   * @default 'bagsSelection.bag-redeem.redeem'
   */
  label: string = 'bagsSelection.bag-redeem.redeem';

  constructor() { }

  ngOnInit(): void {
  }
 /**
   * Método que se llama cuando cambia el valor de `active`.
   * Actualiza la imagen y la etiqueta en función del nuevo valor de `active`.
   * 
   * @param changes Los cambios detectados en las entradas del componente.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if(this.active){
      this.image = './assets/images/checkSimple.svg'
      this.label = 'bagsSelection.bag-redeem.redeemed'
    }else{
      this.image= './assets/images/bags/icon-bag-gift.svg';
      this.label = 'bagsSelection.bag-redeem.redeem'
    }
  }
/**
   * Método que se llama cuando el usuario realiza la acción de canjear la maleta.
   * Emite un evento `onRedeeme` con el valor `true` indicando que el canje ha sido realizado.
   */
  onRedeemed(){
    this.onRedeeme.next(true);
  }

}
